if (!customElements.get('lm-language-picker')) {
  customElements.define('lm-language-picker', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const select = this.querySelector('select[name="language_code"]');
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');
      if (!select || !details || !summary) return;
      select.hidden = true;
      select.disabled = false;
      details.hidden = false;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-language]');
        if (!button || !this.contains(button) || button.disabled) return;
        event.preventDefault();
        select.value = button.dataset.language;
        details.open = false;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }, options);

      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) details.open = false;
      }, options);

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          details.open = false;
          summary.focus();
        }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          const buttons = Array.from(this.querySelectorAll('button[data-language]:not(:disabled)'));
          if (!buttons.length) return;
          event.preventDefault();
          details.open = true;
          const direction = event.key === 'ArrowDown' ? 1 : -1;
          const index = buttons.indexOf(document.activeElement);
          buttons[(index + direction + buttons.length) % buttons.length].focus();
        }
      }, options);
    }

    disconnectedCallback() {
      this.abort?.abort();
    }
  });
}
